import * as React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { FaTimes, FaSave } from "react-icons/fa";
import { connect } from "react-redux";
import { CustomDialogState, RESET_DIALOG } from "./store/CustomDialog";

export interface CustomDialogProps extends CustomDialogState {
    resetDialog: () => void
}

export const CustomDialog: React.FC<CustomDialogProps> = props => {
    const {
        open,
        title,
        message,
        content,
        onSubmit,
        onCancel,
        locales,
        actions,
        resetDialog,
        allowCloseOnBackDropClick
    } = props;

    const handleClose = (event, reason) => {
        if (!allowCloseOnBackDropClick && (reason && (reason === "backdropClick" || reason === "escapeKeyDown"))) {
            return;
        } else {
            resetDialog();
        }
    };

    const handleCancel = () => {
        resetDialog();
        if (onCancel) onCancel();
    }

    const handleSubmit = () => {
        resetDialog();
        if (onSubmit) onSubmit();
    }

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" >
            {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
            <DialogContent style={{ minWidth: '280px' }}>
                {message && <DialogContentText>{message}</DialogContentText>}
                {content && <>{content}</>}
            </DialogContent>
            <DialogActions>
                {(actions && actions.length > 0) ? <>{actions}</> : <>
                    {onCancel && <Button onClick={handleCancel} variant="contained" className="btn-danger p-3 text-white">
                        <span className="btn-wrapper--icon">
                            <FaTimes />
                        </span>
                        <span className="btn-wrapper--label">{locales?.cancelText || 'Cancel'}</span>
                    </Button>}
                    {onSubmit && <Button onClick={handleSubmit} variant="contained" className="btn-primary p-3 text-white">
                        <span className="btn-wrapper--icon">
                            <FaSave />
                        </span>
                        <span className="btn-wrapper--label">{locales?.submitText || 'Ok'}</span>
                    </Button>}
                </>}
            </DialogActions>
        </Dialog>
    );
};


const mapDispatchToProps = (dispatch: any) => {
    return {
        resetDialog: () => dispatch({ type: RESET_DIALOG })
    }
}

const mapStateToProps = (state: any) => ({
    open: state.customDialog.open,
    title: state.customDialog.title,
    message: state.customDialog.message,
    content: state.customDialog.content,
    onSubmit: state.customDialog.onSubmit,
    onCancel: state.customDialog.onCancel,
    locales: state.customDialog.locales,
    actions: state.customDialog.actions,
    allowCloseOnBackDropClick: state.customDialog.allowCloseOnBackDropClick,
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomDialog);